import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import BreadCrumb from "../../components/template/BreadCrumb";
import Header from "../../components/template/Header";
import {
  getVolunteerrequests,
  deleteVolunteerrequest,
  getNextVolunteerrequests,
  getPreviousVolunteerrequests,
} from "../../store/actions/volunteerrequests_action";
import { LIMIT } from "../../domain/constant";
import Pagination from "../../components/common/Pagination";
import Filters from "../../components/common/Filters";
import AddBtn from "../../components/common/AddBtn";
import {
  SEARCH_TERMS,
  view_all_table,
} from "../../shared/enums/volunteerrequests_enum";
import DataTable from "../../components/common/DataTable";
const AllVolunteerrequests = ({
  getVolunteerrequests,
  deleteVolunteerrequest,
  getNextVolunteerrequests,
  getPreviousVolunteerrequests,
  volunteerrequest: { loading, volunteerrequests },
}) => {
  const [page, setPage] = useState(1);
  const [deleteEntry, setDeleteEntry] = useState(null);
  const [q, setQ] = useState(null);
  const [term, setTerm] = useState(null);
  const [termField, setTermField] = useState(SEARCH_TERMS[0]);
  useEffect(() => {
    async function allQuery() {
      if (deleteEntry) {
        await deleteVolunteerrequest(deleteEntry);
      }
      getVolunteerrequests({});
    }
    allQuery();
  }, [deleteEntry]);

  const nextButtonClicked = () => {
    if (volunteerrequests && volunteerrequests.length === LIMIT) {
      const lastVolunteerrequest =
        volunteerrequests[volunteerrequests.length - 1];
      getNextVolunteerrequests({ last: lastVolunteerrequest });
      setPage(page + 1);
    }
  };
  const prevBtnClicked = () => {
    if (page > 1) {
      const lastVolunteerrequest = volunteerrequests[0];
      getPreviousVolunteerrequests({
        first: lastVolunteerrequest,
      });
      setPage(page - 1);
    }
  };
  const filterClicked = () => {
    if (term && term.length > 0) {
      setPage(1);
      setQ(term);
      getVolunteerrequests({ term: term, termField: termField });
    }
  };
  const deleteVolunteerrequestClicked = (id) => {
    setDeleteEntry(id);
  };
  const resetFilter = () => {
    setPage(1);
    setQ(null);
    setTerm("");
    getVolunteerrequests({});
  };

  return (
    <div className="pace-done">
      <div>
        <Header />
        <BreadCrumb
          title="Volunteerrequests"
          mainLinkTitle="Dashboard"
          mainLinkUrl="/dashboard"
          activeLink="Volunteerrequest"
        />

        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12">
              <div
                className="card"
                style={{ boxShadow: "rgb(227 233 243) 0px 4px 22px" }}
              >
                <div className="card-body">
                  <AddBtn item="volunteerrequests" title="Volunteerrequest" />
                  <hr />

                  <Filters
                    q={q}
                    resetFilter={resetFilter}
                    setTerm={setTerm}
                    term={term}
                    filterClicked={filterClicked}
                    termField={termField}
                    setTermField={setTermField}
                    all_terms={SEARCH_TERMS}
                  />
                  <hr />
                  <div>
                    <DataTable
                      keys={view_all_table}
                      data={volunteerrequests}
                      field={"volunteerrequests"}
                      page={page}
                      deleteBtnClicked={deleteVolunteerrequestClicked}
                      loading={loading}
                    />
                    <Pagination
                      data={volunteerrequests}
                      page={page}
                      prevBtnClicked={prevBtnClicked}
                      nextButtonClicked={nextButtonClicked}
                      loading={loading}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  volunteerrequest: state.volunteerrequest,
});

const mapDispatchToProps = {
  getVolunteerrequests,
  deleteVolunteerrequest,
  getNextVolunteerrequests,
  getPreviousVolunteerrequests,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AllVolunteerrequests);
